/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/vrau/"
const MM_LANDING_VIDEO = `${S3_PREFIX}mobile-landing-background.mp4?type=video`

const VRAU: CommunityData = {
  code: "vrau",
  inviteCode: "vrau",
  name: "VRAU",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/vra-030`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      werzLogoColor: "#FFFFFF",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[160px] h-[87px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[87px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#7f44da",
      // aside: no bg (transparent), minimal styles — no padding/gap, no complex bg override
      asideBg: "#7f44da",
      asideStyles: "!p-0 !gap-0 border-r border-[#ffffff]",
      contentBg: "#7f44da",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['InterRegular']",
      primaryButton:
        "bg-[#ffffff] border-2 border-[#ffffff] rounded-[8px] px-[18px] py-[18px] !text-[#000000cc] font-['AkiraExpandedSuperBold'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "!border-r-[1px] border-[#ffffff]",
      separator: "border-[#ffffff]",
      item: "font-['AkiraExpandedSuperBold'] text-[14px] text-[#ffffff] text-center leading-[100%] gap-x-[10px] !pl-0 !py-4 text-opacity-50 border-b border-[#ffffff]",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      // CUSTOM OVERRIDE — container copied from reference
      container: "!bg-[#7f44da] !pb-8",
      titles: "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[26px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        // CUSTOM OVERRIDE — sectionContainer + scrollMenu copied from reference
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-solid border-[#ffffff]",
        sectionTitle:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[26px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          // overflow hidden, transparent item bg (#ffffff00), no border (web rule)
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-transparent",
          // square cards via aspect ratio, no rounding
          mediaContainer: "w-full sm:w-[256px] relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          // content: vertical padding only
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[14px] text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        // CUSTOM OVERRIDE — sectionContainer + scrollMenu copied from reference
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-solid border-[#ffffff]",
        sectionTitle:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[26px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          // overflow hidden, transparent item bg (#ffffff00), no border (web rule)
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-transparent",
          // fixed desktop width, no height — aspect ratio drives media size
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          // content: full-width media on mobile (px-0 py-4), aligned with image top on desktop
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[14px] text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[26px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#7f44da] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-solid border-[#ffffff]",
        // fixed media size, no border (web rule)
        media: "sm:!w-[320px] !w-full sm:!h-[180px] !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[26px] text-left leading-[100%]",
        subtitle:
          "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border-2 border-[#ffffff] rounded-[8px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 gap-y-[6px] text-[#000000cc] font-['AkiraExpandedSuperBold'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-solid border-[#ffffff]",
        header:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-solid border-[#ffffff]",
        header:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        // CUSTOM OVERRIDE — map overflow-hidden, rowGap 10
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[24px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#7f44da] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#7f44da] border-2 border-[#ffffff] rounded-[8px] px-[12px] py-[16px] text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[12px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          // follow reference structure; border-b to separate tickets, vertical padding only
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#ffffff] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[14px] text-left leading-[100%] mb-1",
          description:
            "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[14px] text-left leading-[100%]",
          quantity:
            "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[12px] text-left leading-[100%]",
          status:
            "text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[14px] text-left leading-[100%]",
          counterContainer:
            "bg-[#7f44da] border-2 border-[#ffffff] rounded-[8px] px-[12px] py-[16px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#7f44da] border-2 border-[#ffffff] rounded-[8px] px-[12px] py-[16px] text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[12px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
    // Derived from web styles per .agents/skills/onboard-community/references/wm.md#coming-soon-page (dark purple theme)
    comingSoon: {
      bgColor: "#7f44da", // global.contentBg
      hero: {
        desktop: MM_LANDING_VIDEO, // MM landing background video
        mobile: MM_LANDING_VIDEO, // MM landing background video
        style: "bg-[#5b2fa0]", // darker fallback for dark theme
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`, // global.logo.src
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[92px] h-[50px] sm:w-[160px] sm:h-[87px]", // mobile manual, desktop from web logo
      },
      werzLogoColor: "#FFFFFF", // manual — white on dark bg
      title: "font-['AkiraExpandedSuperBold'] text-[28px] leading-[120%] text-[#ffffff]", // communityLanding.titles
      text: "font-['InterRegular'] text-[16px] leading-[120%] text-[#ffffff]", // communityLanding.shop.text
      button:
        "font-['AkiraExpandedSuperBold'] text-[16px] leading-[100%] p-4 bg-[#ffffff] border-2 border-[#ffffff] rounded-[8px] text-[#000000cc] cursor-pointer w-fit", // global.primaryButton
      input: {
        base: "font-['InterRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#5b2fa0] text-[#ffffff]",
        border: "#a784e0", // lighter for dark theme
        borderFocus: "#ffffff",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['InterRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['InterRegular'] text-[14px] leading-[120%] text-[#d8c9f0]", // muted lavender
      skipButton: "font-['InterRegular'] text-[14px] leading-[120%] text-[#d8c9f0] cursor-pointer",
      modal: {
        container: "bg-[#6d39bd] px-[40px] py-[48px]", // variant of bgColor
        title:
          "font-['AkiraExpandedSuperBold'] text-[24px] leading-[120%] text-[#ffffff] text-center",
        text: "font-['InterRegular'] text-[14px] leading-[120%] text-[#d8c9f0] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#5b2fa0] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#a784e0",
        otpBorderFocus: "#ffffff",
      },
    },
    // Derived from WM + MM atoms per .agents/skills/onboard-community/references/wm.md#links-page (radioradio layout shapes)
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.jpg`, // wmInviteDesktopBg (nonMemberBg)
      bgMobile: `${S3_PREFIX}web-background-non-member.jpg`, // wmInviteMobileBg (nonMemberBg)
      bgColor: "#7f44da",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#7f44da] p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#ffffff]",
        name: "text-[28px] mt-2 text-[#ffffff] font-['AkiraExpandedSuperBold'] leading-[120%]", // mmNewsDetailTitle
        location: "text-[14px] text-[#d8c9f0] font-['InterRegular'] mb-2", // mmNewsItemTitle
        description:
          "text-[16px] leading-[120%] text-[#ffffff] text-center mb-4 font-['InterRegular']", // wmBodyText
        socialMediaIconColor: "#ffffff",
        button:
          "flex justify-center items-center bg-[#7f44da] border-2 border-[#ffffff] rounded-[8px] px-[24px] py-[12px] text-[#ffffff] font-['AkiraExpandedSuperBold'] text-[12px] leading-[100%] cursor-pointer", // wmTicketButton
      },
      upcomingEvents: {
        header:
          "text-[20px] mb-[10px] text-center text-[#ffffff] font-['AkiraExpandedSuperBold'] leading-[120%]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        loadingState:
          "mb-[32px] bg-[#7f44da] font-['InterRegular'] text-[#ffffff] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#ffffff] rounded-[8px]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] rounded-[8px] bg-[#7f44da] flex flex-col justify-center items-center border border-[#ffffff] p-[34px] mb-[32px]",
          title: "text-[#ffffff] text-[14px] mb-1 font-['AkiraExpandedSuperBold']",
          text: "text-[14px] text-[#d8c9f0] font-['InterRegular']",
          button:
            "flex justify-center items-center mt-4 bg-[#7f44da] text-[#ffffff] text-[12px] px-[12px] py-[12px] border-2 border-[#ffffff] rounded-[8px] font-['AkiraExpandedSuperBold'] cursor-pointer",
        },
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] bg-[#7f44da] w-[95vw] rounded-[8px] flex justify-between border border-[#ffffff]",
          duration: "text-[12px] text-[#d8c9f0] font-['InterRegular']",
          name: "text-[16px] leading-[120%] text-[#ffffff] one-line-truncate sm:w-[390px] w-[65vw] font-['AkiraExpandedSuperBold']",
          plusIconColor: "#ffffff",
          media: "border border-[#ffffff] overflow-hidden rounded-[8px] m-2",
        },
        event: {
          container:
            "border border-[#ffffff] rounded-[8px] bg-[#7f44da] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[20px] mb-1 text-[#ffffff] font-['AkiraExpandedSuperBold'] one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[64px] h-[64px] rounded-[6px] bg-[#ffffff] text-[#7f44da] flex flex-col justify-center items-center gap-1 font-['AkiraExpandedSuperBold']",
          duration: "text-[12px] text-[#d8c9f0] font-['InterRegular']",
          location: "text-[12px] text-[#d8c9f0] font-['InterRegular']",
          button:
            "flex justify-center items-center mt-3 bg-[#7f44da] text-[#ffffff] text-[12px] px-[12px] py-[12px] border-2 border-[#ffffff] rounded-[8px] font-['AkiraExpandedSuperBold'] cursor-pointer",
          product: {
            container: "h-[68px] border-t border-[#ffffff] px-4 py-3 flex justify-between",
            name: "text-[16px] text-[#ffffff] font-['AkiraExpandedSuperBold'] one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#ffffff] text-[12px] font-['AkiraExpandedSuperBold']",
            link: "text-[#d8c9f0] text-[12px] font-['InterRegular']",
            status: "text-[#ffffff] text-[14px] font-['AkiraExpandedSuperBold']",
            button:
              "flex justify-center items-center bg-[#7f44da] text-[#ffffff] text-[12px] px-[12px] py-[8px] border-2 border-[#ffffff] rounded-[8px] font-['AkiraExpandedSuperBold'] cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] text-[16px] font-['InterRegular'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#7f44da] font-['InterRegular'] text-[#ffffff] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#ffffff] rounded-[8px]",
        header:
          "text-[20px] mb-[10px] text-center text-[#ffffff] font-['AkiraExpandedSuperBold'] leading-[120%]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#7f44da] sm:w-[500px] w-[95vw] rounded-[8px] flex justify-between border border-[#ffffff]",
          name: "text-[16px] leading-[120%] text-[#ffffff] one-line-truncate sm:w-[390px] w-[65vw] font-['AkiraExpandedSuperBold']",
          triangleIconColor: "#ffffff",
          created: "text-[#d8c9f0] text-[12px] font-['InterRegular']",
          media: "border border-[#ffffff] overflow-hidden rounded-[8px] m-2",
        },
        seeAllNews:
          "text-[#ffffff] text-[16px] font-['InterRegular'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      radioTracks: {
        header:
          "text-[20px] mb-[10px] text-center text-[#ffffff] font-['AkiraExpandedSuperBold'] leading-[120%]",
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[32px] bg-[#7f44da] font-['InterRegular'] text-[#ffffff] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#ffffff] rounded-[8px]",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#7f44da] sm:w-[500px] w-[95vw] rounded-[8px] flex justify-between border border-[#ffffff]",
          title:
            "text-[16px] leading-[120%] text-[#ffffff] one-line-truncate sm:w-[390px] w-[65vw] font-['AkiraExpandedSuperBold']",
          duration: "text-[#d8c9f0] text-[12px] font-['InterRegular']",
          liveType: "text-[#d8c9f0] text-[12px] font-['InterRegular']",
          liveTypeCircle: "#d8c9f0",
          playIconColor: "#7f44da",
          playIconBackgroundColor: "#ffffff",
          playIconBorderColor: "#ffffff",
          start: "text-[#d8c9f0] text-[12px] font-['InterRegular']",
          coverUrl: "border border-[#ffffff] overflow-hidden rounded-[8px] m-2",
        },
        seeAllTracks:
          "text-[#ffffff] text-[16px] font-['InterRegular'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#7f44da] font-['InterRegular'] text-[#ffffff] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#ffffff] rounded-[8px]",
        header:
          "text-[20px] mb-[10px] text-center text-[#ffffff] font-['AkiraExpandedSuperBold'] leading-[120%]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#7f44da] w-[95vw] rounded-[8px] flex justify-between border border-[#ffffff]",
          name: "text-[15px] text-[#ffffff] font-['AkiraExpandedSuperBold']",
          triangleIconColor: "#ffffff",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#ffffff] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "",
      },
    },
  },
}

export default VRAU
